'use client';

import React from 'react';
import { AuthProvider } from "@descope/nextjs-sdk";
import { DESCOPE_BASE_URL, DESCOPE_COOKIE_OPTIONS } from '@/lib/descope-config';

const DescopeProvider: React.FC<{ children: JSX.Element | undefined }> = ({ children }) => {
    if (!process.env.NEXT_PUBLIC_DESCOPE_PROJECT_ID) {
        throw new Error('Please provide a Descope project ID');
    }

    return (
        <AuthProvider
            projectId={process.env.NEXT_PUBLIC_DESCOPE_PROJECT_ID}
            baseUrl={DESCOPE_BASE_URL}
            sessionTokenViaCookie={DESCOPE_COOKIE_OPTIONS}
            refreshTokenViaCookie={DESCOPE_COOKIE_OPTIONS}
        >
            {children}
        </AuthProvider>
    );
};

export default DescopeProvider;